module.exports = __webpack_public_path__ + "img/BBC.60bf0082.png";